export type Councilor = {
  id: string;
  initial: string;
  name: string;
  role: string;
  model: string;
  color: string;
};

export const COUNCIL: Councilor[] = [
  { id: "delphine", initial: "D", name: "Delphine", role: "La Stratège", model: "CLAUDE SONNET 4.6 / OPUS 4.8", color: "#FF1744" },
  { id: "henri",    initial: "H", name: "Henri",    role: "Le Financier", model: "GPT-5.4 MINI / GPT-5.5", color: "#1A2333" },
  { id: "akilah",   initial: "A", name: "Akilah",   role: "L'Analyste de marché", model: "GEMINI 3.5 FLASH", color: "#3D5A40" },
  { id: "eva",      initial: "E", name: "Eva",      role: "Le Marketing", model: "MISTRAL SMALL / LARGE", color: "#FF1744" },
  { id: "ren",      initial: "R", name: "Ren",      role: "Le Business Angel", model: "DEEPSEEK V4 FLASH", color: "#7A2E5C" },
  { id: "julien",   initial: "J", name: "Julien",   role: "Le Pragmatique", model: "PERPLEXITY SONAR / SONAR PRO", color: "#2D5A7A" },
  { id: "imani",    initial: "IM", name: "Imani",   role: "La Voix humaine", model: "COHERE COMMAND A", color: "#FF1744" },
];

export const EMILE: Councilor = {
  id: "emile", initial: "É", name: "Émile",
  role: "Le Contrôleur · Antichambre", model: "CLAUDE SONNET 4.6", color: "#FF1744",
};

const MODE_TO_COUNCILOR: Record<string, string> = {
  "Levée": "delphine",
  "Validation d'idée": "akilah",
  "Pricing": "henri",
  "Marché": "ren",
  "Plan 90 jours": "julien",
  "Tendances": "eva",
  "Produit": "eva",
};

export function councilorForMode(mode: string): Councilor {
  const id = MODE_TO_COUNCILOR[mode] ?? "delphine";
  return COUNCIL.find((c) => c.id === id) ?? COUNCIL[0];
}
